<template>
    <div class="article-detail">
        <div class="banner">
            <div class="title">最新文章</div>
        </div>

        <div class="article-detail-wrap container">
            <div class="breadcrumbs">
                <router-link :to="{ name: 'article'}">
                    <label class="clickable">最新文章</label>
                </router-link>
                <img src="@/assets/img/landingPage/arrow_right.svg"/>
                <label>文章詳情</label>
            </div>
            <div class="title">
                <div>{{article.title}}</div>
            </div>
            <div class="tags-list">
                <div class="tag" v-for="(tag, index) in article.tags" :key="index">{{tag}}</div>
            </div>
            <div class="cover" v-bind:style="{backgroundImage:'url(' + article.cover + ')'}"></div>
            <div class="content">
                <div class="paragraph" v-for="(paragraph, index) in article.content" :key="index">{{paragraph}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted () {
        this.$analytics.logEvent("文章內頁", {
            screen_name: "文章內頁"
        });
    },
    components: {

    },
    data () {
        return {
            article: {
                cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_3.jpeg',
                title: '簡單三步驟，避免租房後才發現隔音差的問題',
                tags: ['租屋', '房東', '房客', '隔間', '租房'],
                content: ['在外租屋族不僅只怕遇到惡房東和惡鄰居，還怕遇到爛隔間，入住後才發現房間隔音有問題，當滿心歡喜的迎接新的住處，進駐後第一晚，一切的美好就立刻結束，隔壁房客的講話聲、音樂聲甚至打呼聲都聽得一清二楚，這時真不知道該怎麼辦，搬走也不是跟房東說也不是，也不想第一晚就跟隔壁房客結下惡緣，只能忍耐到租約到期後搬走。如何避免當冤大頭呢？只要簡單的幾個步驟就可以。', '第一步，在你看房時，用手指頭敲敲四面牆壁，輕輕的叩叩兩聲就可以知道答案，若是聽起來空空虛的像是在敲紙箱，那就要有心理準備，這間房間隔音一定不好，入住後一定不得安寧。現在有許多房東裝修租屋處時喜歡選擇輕隔板來做隔間，從中降低裝修成本，但比起厚實的水泥牆面，這間看似獨立的空間，其實完全沒有隔音的效果，因此敲敲牆壁變成你看房時得做的一件事。', '但現在想要在外租屋，打開租屋網站，多的是隔間套房或雅房，相對水泥牆的房間租金也較低廉，若有預算上的考量，哪有那麼容易避免，這時第二步就要事先與房東了解隔壁房客型態。每個人對於聲音的接受程度不同，當夜深人靜的時候，再細微的聲音都可以被嫌吵，無論是講話聲、電視聲或音樂聲，尤其又是最可怕的低頻率稀疏聲，事先與房東多問一句，了解隔壁房客的型態，也可以多一個思考層面決定是否要簽約租房。', '最後一步則是四周看看水管線，有些房東在降低裝修成本時會選擇現在流行的工業風格，也就是將水管線外露在房間中，如果只有自己的一條水管還好，最怕的是剛好租到水管匯集區，所有的水都從你這間分流出去，其他房間無論是開水關水或沖馬桶，你這間房間都可以聽到流水聲，這時若又遇到晚洗澡的房客，一整晚就聽著流水聲到天亮，因此環顧一下四周，也能降低變成租房冤大頭的風險。']
            }
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .article-detail {
        margin-bottom: 40px;
        .banner {
            display: none;
        }
        .container {
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }
        .article-detail-wrap {
            .breadcrumbs {
                margin-top: 40px;
                label.clickable {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #b1b0b0;
                    cursor: pointer;
                }
                label.clickable:hover {
                    color: #7d7979;
                }
                label{
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #474342;
                    cursor: unset;
                }
                img {
                    margin-left: 12px;
                    margin-right: 12px;
                }
            }
            .title {
                margin-top: 34px;
                margin-bottom: 28px;
                div {
                    font-size: 26px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                }
            }
            .tags-list {
                margin-bottom: 20px;
                .tag {
                    display: inline-block;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #838282;
                    padding: 6px 14px;
                    border-radius: 5px;
                    background-color: #f1f3f6;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .cover {
                height: 400px;
                width: auto;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
            }
            .content {
                margin-top: 40px;
                .paragraph {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                    margin-bottom: 32px;
                }
            }
        }
    }
    @media screen and (max-width: 1100px){
        .article-detail {
            .banner {
                display: block;
                position: relative;
                margin-bottom: 14px;
                height: 198px;
                width: 100%;
                background-image: url('https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;

                .title {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 24px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #ffffff;
                }
            }
            .container {
                width: unset;
                padding: 0 20px;
            }
            .article-detail-wrap {
                .breadcrumbs {
                    display: none;
                }
                .cover {
                    height: 207px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/officailPage/article/articleDetail_3.vue